import React from 'react';
import { Button } from '../Button';
import HStack from '../HStack';

interface ModalFooterProps {
  show?: boolean | undefined;
  onClose?: () => void;
}

export const ModalFooter = ({ show, onClose }: ModalFooterProps) => {
  if (!show) return <></>;
  return (
    <HStack justifyContent={'center'}>
      <Button onClick={onClose}>Cerrar</Button>
    </HStack>
  );
};
